import { TranslateService } from '@ngx-translate/core';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { MessageDeliveryFailureReason } from '@nimbus-global/features/chat/models/chat-twilio.model';

// Less common reasons don't get their own user-facing message - they're appended, as-is, to the
// generic message below so a support agent can act on them without the customer seeing raw jargon.
function getTechnicalFailureReason(
  failureReason: MessageDeliveryFailureReason | null | undefined,
  translateService: TranslateService,
): string {
  switch (failureReason) {
    case MessageDeliveryFailureReason.MessagingWindowExpired:
      return translateService.instant(TranslationKeys.ChatWidgetMessageDeliveryFailureReasonMessagingWindowExpired);
    case MessageDeliveryFailureReason.RateLimited:
      return translateService.instant(TranslationKeys.ChatWidgetMessageDeliveryFailureReasonRateLimited);
    case MessageDeliveryFailureReason.RecipientUnreachable:
      return translateService.instant(TranslationKeys.ChatWidgetMessageDeliveryFailureReasonRecipientUnreachable);
    case MessageDeliveryFailureReason.MessageFiltered:
      return translateService.instant(TranslationKeys.ChatWidgetMessageDeliveryFailureReasonMessageFiltered);
    case MessageDeliveryFailureReason.Unknown:
    case MessageDeliveryFailureReason.None:
    default:
      return translateService.instant(TranslationKeys.ChatWidgetMessageDeliveryFailureReasonUnknown);
  }
}

export function getMessageDeliveryFailureReasonMessage(
  failureReason: MessageDeliveryFailureReason | null | undefined,
  hasMedia: boolean,
  translateService: TranslateService,
): string {
  switch (failureReason) {
    case MessageDeliveryFailureReason.UnsupportedMediaContent:
      return translateService.instant(TranslationKeys.ChatWidgetMessageDeliveryFailureReasonUnsupportedMediaContent);
    case MessageDeliveryFailureReason.ChannelPolicyViolation:
      return translateService.instant(TranslationKeys.ChatWidgetMessageDeliveryFailureReasonChannelPolicyViolation);
    default:
      return hasMedia
        ? translateService.instant(TranslationKeys.ChatWidgetMessageDeliveryFailureReasonGeneric, {
            reason: getTechnicalFailureReason(failureReason, translateService),
          })
        : translateService.instant(TranslationKeys.ChatWidgetMessageDeliveryFailureReasonGenericText);
  }
}
